import { Link } from 'react-router-dom';
import ThemeToggle from '../components/ThemeToggle';
import Footer from '../components/Footer';
import logoImage from '../assets/babysit_logo.png';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-pink-50 dark:from-gray-900 dark:to-gray-800">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <Link to="/" className="flex flex-col items-center justify-center mb-8 hover:opacity-80 transition-opacity">
            <img 
              src={logoImage} 
              alt="Nannity Logo" 
              className="h-16 sm:h-20 w-auto mb-4"
            />
            <span className="text-2xl sm:text-3xl font-bold gradient-bg bg-clip-text text-transparent">
              Nannity
            </span>
          </Link>

          <div className="card">
            <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-gray-900 dark:text-gray-100">
              Politika Privatnosti
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-8">
              Poslednje ažuriranje: {new Date().toLocaleDateString('sr-RS')}
            </p>

            <div className="prose prose-lg dark:prose-invert max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  1. Uvod
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Nannity poštuje vašu privatnost. Ova politika privatnosti objašnjava kako prikupljamo, 
                  koristimo i štitimo vaše lične podatke kada koristite našu platformu.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  2. Podaci koje Prikupljamo
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Prikupljamo sledeće vrste podataka:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 ml-4">
                  <li><strong>Lični podaci:</strong> ime, prezime, email adresa, broj telefona</li>
                  <li><strong>Informacije o nalogu:</strong> uloga (roditelj/dadilja), lokacija, satnica</li>
                  <li><strong>Podaci o korišćenju:</strong> logovi aktivnosti, IP adresa, tip uređaja</li>
                  <li><strong>Platni podaci:</strong> obrađuju se kroz sigurne procesore plaćanja (ne čuvamo detalje kartice)</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  3. Kako Koristimo Vaše Podatke
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Koristimo vaše podatke za:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Pružanje i poboljšanje naše usluge</li>
                  <li>Komunikaciju sa vama o vašem nalogu</li>
                  <li>Obavljanje transakcija i obradu plaćanja</li>
                  <li>Slanje važnih obaveštenja i ažuriranja</li>
                  <li>Poboljšanje sigurnosti i sprečavanje prevara</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  4. Deljenje Podataka
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Ne prodajemo vaše lične podatke. Delimo podatke samo u sledećim slučajevima:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Sa pružaocima usluga koji nam pomažu u radu (npr. hosting, email servisi)</li>
                  <li>Kada je to zakonski zahtevano</li>
                  <li>Za zaštitu naših prava i bezbednosti</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  5. Sigurnost Podataka
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Koristimo industrijski standardne mere sigurnosti za zaštitu vaših podataka, uključujući:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Šifrovanje podataka u prenosu i mirovanju</li>
                  <li>Sigurnosne provere pristupa</li>
                  <li>Redovne sigurnosne revizije</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  6. Vaša Prava
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Imate pravo da:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300 ml-4">
                  <li>Pristupite svojim ličnim podacima</li>
                  <li>Ispravite netačne podatke</li>
                  <li>Zatražite brisanje podataka</li>
                  <li>Ograničite obradu podataka</li>
                  <li>Zatražite prenos podataka</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  7. Kolačići (Cookies)
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Koristimo kolačiće za poboljšanje vašeg iskustva, analizu korišćenja i personalizaciju. 
                  Možete kontrolisati kolačiće kroz podešavanja vašeg pregledača.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  8. Promene u Politici Privatnosti
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                  Možemo povremeno ažurirati ovu politiku privatnosti. Obavestićemo vas o značajnim promenama 
                  preko email-a ili obaveštenja na platformi.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
                  9. Kontakt
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Za pitanja o privatnosti, kontaktirajte nas na: 
                  <a href="mailto:privacy@mnocompany.com" className="text-primary-600 dark:text-primary-400 hover:underline ml-1">
                    privacy@mnocompany.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

